<template>
  <div class="container-fluid pt-0 pr-3" >
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <!-- date of registation -->
      <b-row class="pt-4" align-h="center" v-if="oldRegMode">
        <b-col sm="6">
          <b-input-group >
            <b-input-group-prepend>
            <b-input-group-text >
                <strong>Date Of Registration</strong>
            </b-input-group-text>
            </b-input-group-prepend>
            <b-button  v-if="!this.printMode" @click="display"
            v-b-tooltip.hover :title="dateBtnTip"
            >Text</b-button>
            <b-form-input  id="registration.date" type="date" 
              :state="Boolean(form.registration.date)"
              :disabled="this.printMode" required
              v-model="form.registration.date"
              :formatter="formatRegDate"
              lazy-formatter
            >
            </b-form-input>
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- hatim header & pilgrim's image -->
      <b-row class=" pt-2 pb-0 m-0 ">
        <!-- hatim header -->
        <b-col sm="9" class="">
          <Header id="header" v-if="!oldRegMode" />
        </b-col>
        <!-- browse -->
        <b-col v-if ="!previewUrl" sm="3" class="pl-0" align-v="center"> 
          <strong v-if="english">image</strong>
          <strong v-else>ছবি</strong>
          <b-form-file
          ref="imageInput"
          v-model="form.image"
          placeholder="only jpeg/jpg/png allowed"
          no-drop
          accept="image/jpeg, image/png, image/jpg" 
          @change="onImageSelect"
          />
        </b-col>
        <!-- Preview -->
        <b-col v-else sm="3" class="pl-0" align-v="center">
          <b-img fluid v-if="previewUrl" :src="previewUrl" height="140" width="120" />
          <b-button v-if="previewUrl && !this.printMode" 
          size="sm"
          @click="form.image = null; previewUrl=null"
          v-b-tooltip.hover 
          title="Deletes selected image"
          variant="warning">Cancel image</b-button>
        </b-col>
      </b-row>
      <!-- hlid, Tracking.ID, gender -->
      <b-row class="pt-2" >
        <!-- H.L.ID -->
        <b-col sm="5">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Pilgrim.ID</strong>
                <strong v-else>হজ্জযাত্রী আইডিঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="hlID" type="text"
            readonly
            v-model="form.HLID"  
            ></b-form-input>
          </b-input-group> 
        </b-col>
        <!-- Tracking.ID -->
        <b-col sm="4">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Tracking.ID</strong>
                <strong v-else>Tracking.ID</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="govtID" type="text"
              :disabled="this.printMode"
              v-model="form.trackingID"  
             ></b-form-input>
            <b-form-invalid-feedback id="invalid">
              Enter Govt.ID
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- type -->
        <b-col sm="3">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Gender</strong>
                <strong v-else>লিঙ্গ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="govtID" type="text"
              v-model="form.gender"  :options="type"
              :disabled="this.printMode" required
             />
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- name & father/spouse name & mother's name/ -->
      <b-row class="pt-2 ">
        <!-- prilgrim's Name -->
        <b-col sm="6">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">1.Pilgrim's Name</strong>
                <strong v-else>১।হজ্জযাত্রীর নাম</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="name" type="text" 
              :disabled="this.printMode" required
             :state="Boolean(form.name)" v-model="form.name" 
             placeholder="In English"  ></b-form-input>
            <!-- <b-form-invalid-feedback id="invalid">
              Enter full name
            </b-form-invalid-feedback> -->
          </b-input-group> 
        </b-col>
        <!-- father's name -->
        <b-col sm="6">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">2.Father's Name</strong>
                <strong v-else>২।পিতার নাম </strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="fatherSpouseName" type="text" 
              :disabled="this.printMode"
            aria-describedby="invalid" :state="null" 
            v-model="form.fatherName" placeholder="In English"  ></b-form-input>
            <b-form-invalid-feedback id="invalid">
              Enter full name
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- mother's name -->
        <b-col sm="6" class="pt-2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">3.Mother's Name</strong>
                <strong v-else>৩।মাতার নাম</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="motherName" type="text" 
            aria-describedby="invalid" :state="null" v-model="form.motherName" 
              :disabled="this.printMode"
            placeholder="In English"  ></b-form-input>
            <b-form-invalid-feedback id="invalid">
              Enter full name
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- spouse's name -->
        <b-col sm="6" class="pt-2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="form.gender=='Female'">৪।স্বামীর নাম</strong>
                <strong v-if="form.gender=='Male'">৪।স্ত্রীর নাম</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="nameInBangla" type="text" aria-describedby="invalid"
              :disabled="this.printMode"
             :state="null" v-model="form.spouseName" 
             placeholder="Spouse's Name "></b-form-input>
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- dob & place of birth & age  -->
      <b-row class="pt-2">
        <!-- dob -->
        <b-col sm="5">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">4.Date of Birth</strong>
                <strong v-else>৫।জন্ম তারিখঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-button v-if="!this.printMode" @click="display"
              v-b-tooltip.hover :title="dateBtnTip"
            >Text</b-button>
            <b-form-input  id="dob" type="date" data-date-format="DD MMM YYYY"
            :state="Boolean(form.dob)"
            :disabled="this.printMode"
            v-model="form.dob"
            :formatter="formatDate"
            lazy-formatter
            >
            </b-form-input>
          </b-input-group> 
        </b-col>
        <!-- age -->
        <b-col sm="2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Age</strong>
                <strong v-else>বয়সঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="dob" type="number"
             readonly v-model="calcAge" ></b-form-input>
          </b-input-group> 
        </b-col>
        <!-- Birth place -->
        <b-col sm="3">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Birth Place</strong>
                <strong v-else>জন্মস্থানঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select  id="placeOfBirth" :options="place"
            :disabled="this.printMode"
            v-model="form.placeOfBirth" />
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- Education & profession & nid & blood Group -->
      <b-row class="pt-2">
        <!-- education -->
        <b-col sm="6">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">5.Education</strong>
                <strong v-else>৬।শিক্ষাগত যোগ্যতাঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="education" :state="null"
             :disabled="this.printMode"
             :options="education" v-model="form.education" />
            <b-form-invalid-feedback id="invalid">
              select education level
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- profession -->
        <b-col sm="6">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Profession</strong>
                <strong v-else>পেশাঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="profession" :options="professions" 
             :disabled="this.printMode"            
             :state="Boolean(form.profession)"
            type="text"  v-model="form.profession" />
            
          </b-input-group> 
        </b-col>
        <!-- nid -->
        <b-col sm="6" class="pt-2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">6.NID</strong>
                <strong v-else>৭।জাতীয় পরিচয়পত্র নংঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="nid" type="text" 
             :disabled="this.printMode"            
            :state="Boolean(form.nid)" v-model="form.nid" />
            <!-- <b-form-invalid-feedback id="invalid">
              enter national ID
            </b-form-invalid-feedback> -->
          </b-input-group> 
        </b-col>
        <!-- blood group -->
        <b-col sm="4" class="pt-2" >
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong>Blood Group</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="bloodGroup" :options="bloodGroup" 
             :disabled="this.printMode"
            aria-describedby="invalid" :state="null" v-model="form.bloodGroup" />
            <b-form-invalid-feedback id="invalid">
              select blood group
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- phone, passportno &  date of issue & expiration & mobile-->
      <b-row class="pt-2">
        <!-- phone -->
        <b-col sm="6">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">7.Phone</strong>
                <strong v-else>৮।মোবাইলঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="phone" type="text" :state="Boolean(form.phone)"
            v-model="form.phone"  
             :disabled="this.printMode"
            placeholder="01X-XXXXXXXX, 01X-XXXXXXXX"
            ></b-form-input>
          </b-input-group>
        </b-col>  
        <!-- passport no -->
        <b-col sm="4">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">8.Passport No</strong>
                <strong v-else>৯।পাসপোর্ট নংঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="passportNo" type="text" aria-describedby="invalid"
             :disabled="this.printMode"
             :state="null" v-model="form.passportNo"  ></b-form-input>
            <b-form-invalid-feedback id="invalid">
              double check passport number
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- date of issue -->
        <b-col sm="5" class="pt-2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Issue Date</strong>
                <strong v-else>ইস্যুর তারিখঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-button v-if="!this.printMode" @click="display"
            >Text</b-button>
            <b-form-input  id="passportIssue" type="date" data-date-format="DD MMM YYYY" 
              :disabled="this.printMode"
              v-model="form.passportIssue"
              :formatter="formatDate"
              lazy-formatter
            ></b-form-input>
            <b-form-invalid-feedback id="invalid">
              select passport issue date 
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
        <!-- Date of expire -->
        <b-col sm="5" class="pt-2">
          <b-input-group >
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Expiration Date</strong>
                <strong v-else>মেয়াদ উত্তীর্ণের তারিখঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-button  v-if="!this.printMode" @click="display"
            >Text</b-button>
            <b-form-input  id="passportExp" type="date" data-date-format="DD MMM YYYY" 
             :disabled="this.printMode"
            v-model="form.passportExp" 
            :formatter="formatDate"
            lazy-formatter              
            />
            <b-form-invalid-feedback id="invalid">
              select passport issue date
            </b-form-invalid-feedback>
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- present address -->
      <b-row class="pt-4 pl-3">
        <strong v-if="english">9.Present Address, As in passport</strong>
        <strong v-else>১০।বর্তমান ঠিকানা পাসপোর্ট অনুযায়ীঃ</strong>
      </b-row>
      <!-- present -->
      <b-row class="pt-1">
        <!-- village/house road -->
        <b-col sm="6" class="">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Village/House & Road</strong>
                <strong v-else>গ্রাম/বাড়ী নং ও রোড নংঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="presentAddrVhr"
             :disabled="this.printMode"
            v-model="form.presentAddr.vhr" 
            placeholder="Village#..., House#.., Road#.." />
          </b-input-group>
        </b-col>    
        <!-- Post Office -->
        <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Post Office</strong>
                  <strong v-else>ডাকঘরঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="po" 
              :disabled="this.printMode"
              v-model="form.presentAddr.po" 
              placeholder="Enter post Office" />
            </b-input-group>
        </b-col>
        <!-- Post Code -->
        <b-col sm="3" class="">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Post Code</strong>
                  <strong v-else>পোস্টকোডঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="pc" type="number" 
              :disabled="this.printMode"
              v-model="form.presentAddr.pc"  
              placeholder="Enter post code" />
            </b-input-group>
        </b-col>
        <!-- swapable district and thana -->
        <b-container class="m-0">
          <b-row>
            <!-- District -->
            <b-col sm="5" ref="preDistrictCol" class="pt-2">
                <b-input-group >
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">District</strong>
                      <strong v-else>জেলাঃ</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-select id="district" 
                  :options="place" 
                  :disabled="this.printMode"
                  v-model="district"  
                  />
                </b-input-group>
            </b-col> 
            <!-- Police Station -->
            <b-col sm="5" ref="preThanaCol"  class="pt-2">
                <b-input-group  >
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Police Station</strong>
                      <strong v-else>উপজেলা/থানাঃ</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-select id="ps" 
                  :disabled="this.printMode"
                  :options="thana1" 
                  v-model="form.presentAddr.policeStation"  />
                </b-input-group>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
      <!-- if parmanent address same -->
      <b-row class="pt-4 pl-3">
        <strong v-if="english">10.Parmanent Address</strong>
        <strong v-else>১১।স্থায়ী থিকানাঃ</strong>
        <b-col v-if="!this.printMode">
          <b-form-checkbox 
          plain
          v-model="form.sameAsPresent"
          value="same"
          unchecked-value="notSame"
          @change="setPresentAsParmanent"
          >
          <!-- <strong v-if="form.sameAsPresent!='same'">Same as present</strong> -->
          <strong>Same as present</strong>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <!-- parmanent -->
      <b-row class="pt-1" > 
        <!-- village/house road -->
        <b-col sm="6" class="">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Village/House & Road</strong>
                <strong v-else>গ্রাম/বাড়ী নং ও রোড নংঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="presentAddrVhr"
              :disabled="this.printMode"
            v-model="form.parmanentAddr.vhr" 
            placeholder="Village#..., House#.., Road#.." />
          </b-input-group>
        </b-col>    
        <!-- Post Office -->
        <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Post Office</strong>
                  <strong v-else>ডাকঘরঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="po" 
              :disabled="this.printMode"
              v-model="form.parmanentAddr.po" 
              placeholder="Enter post Office" />
            </b-input-group>
        </b-col>
        <!-- Post Code -->
        <b-col sm="3" class="">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Post Code</strong>
                  <strong v-else>পোস্টকোডঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="pc" type="number" 
              :disabled="this.printMode"
              v-model="form.parmanentAddr.pc"  
              placeholder="Enter post code" />
            </b-input-group>
        </b-col>
        <!-- swapable district and thana -->
        <b-container class="m-0">
          <b-row>
            <!-- District -->
            <b-col ref="parDistrictCol" sm="5" class="pt-2">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">District</strong>
                      <strong v-else>জেলাঃ</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-select id="district" 
                  :disabled="this.printMode"
                  :options="place" 
                  v-model="parmanentDistrict"  />
                </b-input-group>
            </b-col> 
            <!-- Police Station -->
            <b-col ref="parThanaCol" sm="5" class="pt-2">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Police Station</strong>
                      <strong v-else>উপজেলা/থানাঃ</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-select id="ps" 
                  :disabled="this.printMode"
                  :options="thana2" 
                  v-model="form.parmanentAddr.policeStation"  />
                </b-input-group>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
      <!-- the question -->
      <b-row class="pt-3" v-if="form.gender=='Female'">
          <b-col sm="7" class="">
            <strong v-if="english">11.For women, will husband acompany her?</strong>
            <strong v-else>১২। মহিলাদের ক্ষেত্রে প্রযোজ্য স্বামী এক সঙ্গে হজ্জে যাবেন কিনা (✔) চিহ্ন দিনঃ</strong>
          </b-col>
          <!-- yes/no -->
          <b-col class="p-0 m-0" sm="4" >
            <b-form-checkbox
            plain
            size=""
            v-model="form.womenWithoutSpouse.status"
            value="yes"
            unchecked-value=""
              :disabled="this.printMode"
            inline
            >
            <strong v-if="english">Yes</strong>
            <strong v-else>হ্যাঁ</strong>
            </b-form-checkbox>
            <b-form-checkbox
            plain
            size=""
            v-model="form.womenWithoutSpouse.status"
            value="no"
            unchecked-value=""
              :disabled="this.printMode"           
            inline
            >
            <strong v-if="english">No</strong>
            <strong v-else>না</strong>
            </b-form-checkbox>
          </b-col>
      </b-row>
      <!-- woman Without husband -->
      <b-collapse class="pt-1" id="companionForm"  v-if="form.gender=='Female'" v-model="showCompanionForm">
        <!-- <strong v-if="english">Islam permitter companion</strong> -->
        <strong v-if="form.womenWithoutSpouse.status=='yes'">১৩। স্বামী সঙ্গে গেলে</strong>
        <strong v-if="form.womenWithoutSpouse.status=='no'">১৩। স্বামী সঙ্গে না গেলে শরীয়ত সম্মত মাহরমের </strong>
      </b-collapse>  
      <!-- collapse -->
      <b-row class="pt-2"  v-if="form.gender=='Female'" >
        <!-- if no -->
        <!-- name -->
        <b-col sm="6" class="">
          <b-collapse id="companionForm" v-model="showCompanionForm">
            <!-- companion name -->
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Name</strong>
                  <strong v-else>নামঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="companionName" 
              :disabled="this.printMode"
              v-model="form.womenWithoutSpouse.companionName" 
              placeholder="Enter his name" />
            </b-input-group>
          </b-collapse>
        </b-col>
        <!-- relation -->
        <b-col sm="6" >
          <b-collapse id="companionForm" v-model="showCompanionForm">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Relation</strong>
                  <strong v-else>সম্পর্কঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select id="relation"
              :disabled="this.printMode"
              :options="relations" 
              v-model="form.womenWithoutSpouse.relation" 
              placeholder="Her relation with him" />
            </b-input-group>
          </b-collapse>
        </b-col>
        <!-- his passport -->
        <b-col sm="6" class="pt-2">
          <b-collapse id="companionForm" v-model="showCompanionForm">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <!-- <strong v-if="english">Passport</strong> -->
                  <strong v-if="form.womenWithoutSpouse.status=='yes'">স্বামীর পাসপোর্ট নম্বরঃ</strong>
                  <strong v-if="form.womenWithoutSpouse.status=='no'">মাহরমের পাসপোর্ট নম্বরঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="companionPassportNo" 
              :disabled="this.printMode"
              v-model="form.womenWithoutSpouse.companionPassportNo"  
              placeholder="Enter his passport number" />
            </b-input-group>
          </b-collapse>
        </b-col>
        <!-- his mobile -->
        <b-col sm="6" class="pt-2">
          <b-collapse id="companionForm" v-model="showCompanionForm">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Phone</strong>
                  <strong v-else>মোবাইলঃ</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="companionPhone"  
              :disabled="this.printMode"
              type="text"
              v-model="form.womenWithoutSpouse.phone"  
              placeholder="01X-XXXXXXXX, 01X-XXXXXXXXX"
              />
            </b-input-group>
            <!-- <b-form-text><strong >put commna(,) to add multiple numbers </strong></b-form-text> -->
          </b-collapse>
        </b-col>
      </b-row>
      
      <!-- emgergency label -->
      <b-row class="pt-2 pl-3"> 
        <strong v-if="english">14.Emergency Contact</strong>
        <strong v-else>১৪।জরুরী প্রয়োজনে যোগাযোগ</strong>
      </b-row>
      <!-- emmergency contact -->
      <b-row class="pt-1">
        <!-- name -->
        <b-col sm="4" class="pr-0">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Name</strong>
                <strong v-else>নামঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="eName" 
              :disabled="this.printMode"

            v-model="form.emergencyContact.name" 
            placeholder="Enter Name" />
          </b-input-group>
        </b-col>
        <!-- Relation -->
        <b-col sm="3">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Relation</strong>
                <strong v-else>সম্পর্কঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="eRelation" 
              :disabled="this.printMode"

            v-model="form.emergencyContact.relation" 
            placeholder="enter Relation" />
          </b-input-group>
        </b-col>
        <!-- Mobile-->
        <b-col sm="" class="pl-0">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong v-if="english">Mobile</strong>
                <strong v-else>মোবাইলঃ</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input id="eMobile" type="text" 
              :disabled="this.printMode"
            v-model="form.emergencyContact.phone"  
            placeholder="01X-XXXXXXXX, 01X-XXXXXXXX" />
          </b-input-group>
        </b-col>
      </b-row>
      <!-- disclaimer -->
      <b-row class="pt-0">
        <b-col sm="12">
        <Footer v-if="!oldRegMode"/>
        </b-col>
      </b-row>
   
      <!-- form buttons -->
      <b-row id="buttons" class="pt-3" align-h="around">
        <!-- save -->
        <b-col  cols="0" v-if='!printMode && editMode'>
          <b-button variant="info" @click="onSave" 
          v-b-tooltip.hover 
          title="update informations"
          >Save</b-button>
        </b-col>
        <!-- register -->
        <b-col cols="0" v-if='!editMode && !printMode'> 
          <b-button size="" type="submit" variant="success"
          v-b-tooltip.hover 
          title="Need to fill all the required informations to complete"
          >Register</b-button>
          <!-- <b-form-text><strong> Need to fill all the required informations to complete</strong></b-form-text> -->
        </b-col>
        <!-- print -->
        <b-col cols="0" v-if='printMode'> 
          <b-button @click="onPrint" variant="dark"
          >Print</b-button>
        </b-col>
        <!-- reset -->
        <b-col cols="0" v-if='!printMode'> 
          <b-button type="reset" variant="warning"
          v-b-tooltip.hover 
          title=""
          >Cancel</b-button>
           <!-- <b-form-text><strong>set to default values</strong></b-form-text> -->
        </b-col>  
      </b-row>
      <br/>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import VueNotifications from 'vue-notifications'
import Header from './regHeader'
import Footer from './regFooter'
import districtThana from './DistrictThana.js'
import datePicker from 'vuejs-datepicker'

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default {
  name: 'pilgrimRegistration',
  components:{
        Header,
        Footer,
        datePicker
  },
  props:[
    'oldData'
  ],
  computed:{
    calcAge: function(){
      if(this.form.dob){
        var birthday = new Date(this.form.dob);
        this.form.age = ~~((Date.now() - birthday) / (31557600000));
        return this.form.age;
      }
    },
    district:{
      get(){
        return this.form.presentAddr.district;
      },
      set(val){
        this.form.presentAddr.district = val;
        this.thana1=[{text:"", value:null}];
        if(this.form.presentAddr.district){
          districtThana[ this.form.presentAddr.district ].forEach((elm, it)=>{
            this.thana1.push(elm);
          })
        }
        // console.log(this.thana1);
      }
    },
    parmanentDistrict:{
      get(){
        return this.form.parmanentAddr.district;
      },
      set(val){
        this.form.parmanentAddr.district = val;
        this.thana2=[{text:"select a thana", value:null}];
        if(this.form.parmanentAddr.district){
          districtThana[ this.form.parmanentAddr.district ].forEach((elm, it)=>{
            this.thana2.push(elm);
          })
        }
        // console.log(this.thana2);
      }
    },
    showCompanionForm:{
      get(){
        if(this.form.womenWithoutSpouse.status == "no" || this.form.womenWithoutSpouse.status == "yes" ){
          // this.showCompanionForm=true;
          return true;
        }
        else return false;
      },
      set(val){}
    }
  },
  created(){
    // console.log(this.oldData);

    Object.keys(districtThana).forEach((elm,it)=>{
      this.place.push(elm);
    })
    if(typeof this.$route.params.pilgrim == 'object'){
      Object.assign(this.form, this.$route.params.pilgrim);
      this.previewUrl = this.form.image +'?'+Date();      
      if(this.form.presentAddr.district){
        districtThana[ this.form.presentAddr.district ].forEach((elm, it)=>{
          this.thana1.push(elm);
        })
      }
      if(this.form.parmanentAddr.district){
        districtThana[ this.form.parmanentAddr.district ].forEach((elm, it)=>{
          this.thana2.push(elm);
        })
      }
      if(this.$route.params.mode==='edit'){
        this.editMode=true;
        this.prevImage=this.form.image;
      }
      if(this.$route.params.mode==='print'){
        this.printMode=true;
      }
      if(this.$route.params.mode==='view'){
        this.viewMode=true;
      }
    }
    if(this.oldData==='yes'){
      this.oldRegMode=true;
    }
  },
  data() {
    return {
      show: true,
      elmProp:{readonly:false},
      update:0,
      dateBtnTip:"click to enable copy/paste",
      dateSwitch:false,
      editMode:false,
      printMode:false,
      viewMode:false,
      oldRegMode:false,
      previewUrl:null,
      english:false,
      year:0, //for database year colomn 
      DBID:"",
      prevImage:null,
      form: {
        image:null,
        HLID:"",
        trackingID:"",
        gender:null,
        name:null,
        fatherName:"",
        motherName:"",
        spouseName:"",
        dob:null,
        age:"",
        placeOfBirth:null,
        education:null,
        profession:null,
        nid:null,
        bloodGroup:null,
        phone:null,
        passportNo:"",
        passportIssue:"",
        passportExp:"",
        presentAddr:{
          vhr:"",
          po:"",
          pc:"",
          policeStation:null,
          district:null
        },
        sameAsPresent:"notSame",
        parmanentAddr:{
          vhr:"",
          po:"",
          pc:"",
          policeStation:null,
          district:null
        },
        womenWithoutSpouse:{
          status:"",
          companionName:"",
          relation:null,
          companionPassportNo:"",
          phone:""
        },
        emergencyContact:{
          name:"",
          relation:"",
          phone:""
        },
        registration:{
          status: "",
          date:""
        },
        payment:{
          paid:0,
          count:0
        }
      },
      type:[
        {text:"Select Gender", value:null},
        "Male",
        "Female"
      ],
      relations:[
        {text:"Select one", value:null},
        "Brother", "Father", "Father-in-law", "Grandfather", "Grandson", "Husband", "Nephew", "Son", "Son-in-law",
        "Stepfather", "Stepson", "Uncle"
      ],
      professions:[
        {text:"Select one", value:null},
        "Business","Dependent","Farmer", "Govt. Service", "House Wife", "Other Profession", "Private Service",
        "Retired", "Student"        
      ],
      bloodGroup:[
        { text: "Select one", value: null },
        "A+","A-","AB+","AB-","B+","B-","O+","O-","N/A"
      ],
      education:[
        { text: "Select one", value: null },
        "Primary Level",
        "High School Level",
        "College Level",
        "Graduate Level",
        "Masters Level",
        "Ph.D"
      ],
      place:[{text:"select a district", value:null}],
      thana1:[],
      thana2:[]
    };
  },
  methods: {
    formatDate(val,evt){
      // console.log(evt);
      if(val){
        var d = new Date(val);
        if(d != 'Invalid Date'){
          this.form[evt.path[1].childNodes[4].id] = d.getFullYear() + "-" +('0' + (d.getMonth()+1)).slice(-2) + '-' + ( '0'+ d.getDate()).slice(-2) ;
          return val;
        }
        else{
          this.form[evt.path[1].childNodes[4].id] = null;
          this.showErrorMsg({title:"Wrong date format", timeout:5000})
        }
      }
    },
    formatRegDate(val,evt){
      // console.log(evt);
      if(val){
        var d = new Date(val);
        if(d != 'Invalid Date'){
          this.form.registration.date = d.getFullYear() + "-" +('0' + (d.getMonth()+1)).slice(-2) + '-' + ( '0'+ d.getDate()).slice(-2) ;
          return val;
        }
        else{
          this.form.registration.date = null;
          this.showErrorMsg({title:"Wrong date format", timeout:5000})
        }
      }
    },
    display(evt){
      // console.log(
      //   'dob:'+this.form.dob+
      //   '\npassportIssue:'+this.form.passportIssue+
      //   '\npassportExp:'+this.form.passportExp
      // );
      console.log(this.form.registration.date);
      if(evt.path[0].innerText=='Text'){
        this.dateBtnTip="click to enable date selector";
        evt.path[0].innerText='Date';
        evt.path[1].childNodes[4].type='text';
      }
      else{
        this.dateBtnTip="click to enable copy/paste";
        evt.path[0].innerText='Text';
        evt.path[1].childNodes[4].type='date';
      }
    },
    swapDistrictThana(col, elm){
      // console.log(col);
      // console.log(elm);
      elm.parentNode.insertBefore(elm,elm.parentNode.firstChild);
    },
    regComplete(){ //check name, dob, profession, nid, phone
      if(!this.form.name || !this.form.dob || !this.form.profession || !this.form.nid || !this.form.phone ){
        this.form.registration.status="Incomplete";
        return false;
      }
      else{
        this.form.registration.status="Complete";
        return true;
      }
    },
    onSave(evt){ //url hard coded
      if(!this.regComplete()){
        this.showWarnMsg({title:"informations are incomplete, will try to save for later completion", timeout:3000});
      }
      if(this.form.image && this.prevImage != this.form.image){
          this.submitImage();
          // this.form.image = ('http://localhost:8080/images/'+this.form.image.name);
          this.form.image = ('images/'+this.form.image.name);
      }
      this.updatePilgrimData();

    },
    onSubmit(evt) { //url hard coded
      evt.preventDefault();
      if(!this.regComplete()){
        this.showWarnMsg({title:"informations are incomplete, will try to save for later completion", timeout:3000});
      }    
      this.genHLID()
      .then(()=>{
        if(this.form.image){
          this.submitImage()
        }
        // else  {this.form.image = 'images/blank.png'}
      })
      .then(()=>{
        if(this.form.image){
          // this.form.image = ('http://localhost:8080/images/'+this.form.image.name);
          this.form.image = ('images/'+this.form.image.name);
        }
        this.submitPilgrimData()
      })
    },
    onReset(evt) {
      if(!this.editMode){
        this.showWarnMsg({title:"Registration canceled, unsaved data will be lost!",timeout:5000});
      }
      this.$router.push({name:'Manage'});
    },
    onPrint(evt){
      // evt.preventDefault();
      var originalTitle = document.title;
      document.title=this.form.name;
      // swap distric and thana position
      this.swapDistrictThana(this.$refs.preDistrictCol, this.$refs.preThanaCol);
      this.swapDistrictThana(this.$refs.parDistrictCol, this.$refs.parThanaCol);
      window.print();
      this.showInfoMsg({title:"Print window opened", timeout:5000});
      document.title = originalTitle;
      // swap distric and thana position again
      this.swapDistrictThana(this.$refs.preThanaCol, this.$refs.preDistrictCol);
      this.swapDistrictThana( this.$refs.parThanaCol, this.$refs.parDistrictCol);
    },
    submitImage(){
      //change file name to HLID.ext 
      //                new File(      [prev file],         "HLID"    .                  "ext"                     );
      // this.form.HLID = '30-mar-2019-80'
      this.form.image = new File([this.form.image], (this.form.HLID +'.'+(this.form.image.name.split('.').pop()) ) );
      let formData = new FormData();
      formData.append('file', this.form.image);
      // console.log('images/'+this.form.image.name);

      // axios.post( 'http://192.168.100.107:8080/pilgrimDB/storeImage.php',
      axios.post( 'pilgrimDB/storeImage.php',
        formData, { headers: {
          'Content-Type': this.form.image.type
          }, withCredentials: true
        }
      )
      .then(response=>{
        if(response.data == 1 ){
          this.showInfoMsg({title:this.form.name+"'s image uploaded" });
        }
        else{
          // this.form.image = 'images/blank.png'        ;
          this.showWarnMsg({title:this.form.name+"'s image was not uploaded" });
        }
        // console.log(response);
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    submitPilgrimData(){
      let formData = new FormData();
      formData.append('id', this.DBID);
      formData.append('HLID', this.form.HLID);
      formData.append('information', JSON.stringify(this.form, null, 0));
      formData.append('year', this.year);
      // axios.post( 'http://192.168.100.107:8080/pilgrimDB/storeData.php',
      axios.post( 'pilgrimDB/storeData.php',
        formData, { headers: {
          'Content-Type': 'multipart/form-data'
          }, withCredentials: true
        }
      ).then(response=>{
        if(response.data==1){
          this.showSuccessMsg({title: this.form.name+"'s registration is saved"})
          this.$router.push({name:'Manage'})
        }
        else{
          this.showErrorMsg({title:"Something went wrong in serverDB"})
        }
        console.log(response);
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    updatePilgrimData(){
      let formData = new FormData();
      formData.append('HLID', this.form.HLID);
      formData.append('information', JSON.stringify(this.form, null, 0));
      // axios.post( 'http://192.168.100.107:8080/pilgrimDB/updateData.php',
      axios.post( 'pilgrimDB/updateData.php',
        formData, { headers: {
          'Content-Type': 'multipart/form-data'
          }, withCredentials: true
        }
      ).then(response=>{
        if(response.data==1){
          this.showSuccessMsg({title: this.form.name+"'s information is updated"})
          this.$router.push({name:'Manage'})
        }
        else{
          // console.log(response);
          // this.showErrorMsg({title:"No data "})
          this.$router.push({name:'Manage'})

        }
        console.log(response);
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    onImageSelect(e){
      this.form.image = e.target.files[0];
      this.previewUrl = URL.createObjectURL(this.form.image);
    },
    setPresentAsParmanent(e){
      if(this.form.sameAsPresent != "same"){
        Object.assign(this.form.parmanentAddr, this.form.presentAddr);
      }
    },
    getDBID(){
      // return axios.get( 'http://192.168.100.107:8080/pilgrimDB/DBID.php',{withCredentials: true})
      return axios.get( 'pilgrimDB/DBID.php',{withCredentials: true})
      .then(response=>{
        this.DBID = response.data[0]['LAST_INSERT_ID()'];
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
        // return
      });
    },
    makeHLID(){ //will set this.year also
      if(this.oldRegMode){ //for older registrations
        let tmp =  (this.form.registration.date).split('-'); 
        let formatted_date ="";
        formatted_date = tmp[2]; //day
        formatted_date += '-' +  monthNames[parseInt(tmp[1]) - 1 ] ; //month
        formatted_date += '-' + tmp[0]; //year
        this.year = tmp[0];
        this.form.registration.date= formatted_date;
        return (formatted_date+'-'+ this.DBID);
      }
      else{ //for new registration
        var d = new Date();
        this.year = d.getFullYear();
        this.form.registration.date = d.getDate()  + "-" + monthNames[(d.getMonth())] + "-" + d.getFullYear();
        return (this.form.registration.date +'-'+ this.DBID);
      }
    },
    genHLID(){
      return this.getDBID()
      .then(() =>{
        this.form.HLID = this.makeHLID();
      })
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
};
</script>
<style>
  #hlID, #govtID, #name, #nameInBangla, 
  #fatherSpouseName,#motherName,
  #dob,#age,#placeOfBirth,
  #education,#profession,
  #nid,#bloodGroup,
  #passportNo,#passportIssue,
  #passportExp,#phone,#email,
  #presentAddrVhr,#po,#pc,#ps,#district,
  #eName,#eRelation,#eMobile,
  #companionName,#relation,#companionPassportNo,#companionPhone,
  #registration.date
  /* #footer */
  {
    color:black ;
    font-size: 16px;
  }

 @media print{
    html, body {
      margin-top:0mm !important;
      margin:0mm 0mm 0mm 0mm !important;
      padding-top:0mm !important;
    }
    #name,#dob, #profession, #nid, #phone{
      border-color:none !important;
      background-image:none !important;
    }

    #label{visibility: visible !important;}
    #buttons { display: none; }
    #hlID, #govtID, #name, #nameInBangla, 
    #fatherSpouseName,#motherName,
    #dob,#age,#placeOfBirth,
    #education,#profession,
    #nid,#bloodGroup,
    #passportNo,#passportIssue,
    #passportExp,#phone,#email,
    #presentAddrVhr,#po,#pc,#ps,#district,
    #eName,#eRelation,#eMobile,
    #companionName,#relation,#companionPassportNo,#companionPhone
    {
      pointer-events: none !important;
      /* color:black ; */
      /* font-size: 18px; */
      display: block !important;
      /* top: 0mm; */
      /* margin: 0mm; */
      /* box-shadow: 0; */
    }
    #non-printable { display: none !important; }
     
}

@page { 
    size:auto !important;
    margin: 0mm !important;
} 
  
</style>
